import { ChartBellCurveCumulativeIcon } from './ChartBellCurveCumulativeIcon';

/**
 * author: Michael Irigoyen
 * id D4E38BC9-5A85-4890-B3DD-92F3D263E26E
 * name chart-bell-curve-cumulative
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bell-curve-cumulative.svg
 * tags
 * - Math 
 */
export const WidgetBellCurveCumulativeIcon = ChartBellCurveCumulativeIcon;
export default WidgetBellCurveCumulativeIcon